// extracted by mini-css-extract-plugin
export default {"root":"LayoutSingleColumn_root__-Rcsa","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__NmLnV"};